
import { useState } from 'react';

export default function TreatmentsSection() {
  const [selectedTreatment, setSelectedTreatment] = useState(null);

  const treatments = [
    {
      id: 1,
      title: 'Cirugía de recontrucción uretral',
      description: 'Cirugía utilizada para reparar estrecheces, lesiones o defectos de la uretra.',
      icon: 'ri-heart-line',
      color: 'teal',
      details: 'especializado en el diagnóstico y tratamiento de estenosis uretrales, cicatrices y lesiones uretrales.',
      benefits: ['Mejor estetica', 'mejor función uretral', 'Tratamiento de cicatrices uretrales', 'Menor dolor postoperatorio'],
      image: 'https://i0.wp.com/drreneheredia.com/wp-content/uploads/2017/09/uretra.jpg?fit=1000%2C650&ssl=1'
    },
    {
      id: 2,
      title: 'Cirugía Urologica de Riñón',
      description: 'Nefrectomía parcial y radical urológica',
      icon: 'ri-drop-line',
      color: 'green',
      details: 'Cirugía robótica para tumores renales preservando la máxima función renal posible.',
      benefits: ['Preservación renal', 'Incisiones mínimas', 'Menos complicaciones', 'Estancia hospitalaria corta'],
      image: 'https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/118e672b036ef113f7a7f0f7450674dd.jpeg'
    },
    {
      id: 3,
      title: 'Tratamiento Disfunción Eréctil',
      description: 'Terapias avanzadas y cirugía reconstructiva',
      icon: 'ri-pulse-line',
      color: 'purple',
      details: 'Tratamientos integrales desde terapias médicas hasta implantes peneanos con tecnología de vanguardia.',
      benefits: ['Múltiples opciones', 'Resultados duraderos', 'Mínima invasión', 'Alta satisfacción'],
      image: 'https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/80103657c907dced62c961ce427ce82b.webp'
    },
    {
      id: 4,
      title: 'Tratamiento VPH',
      description: 'Láser CO2 y terapias especializadas',
      icon: 'ri-shield-cross-line',
      color: 'red',
      details: 'Tratamiento integral del VPH con láser CO2 de alta precisión y seguimiento especializado.',
      benefits: ['Láser de precisión', 'Sin cicatrices', 'Recuperación rápida', 'Seguimiento integral'],
      image: 'https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/6dd5713c9e9949560d3e2a318cf851bf.png'
    },
    {
      id: 5,
      title: 'Cirugía Láser de Próstata',
      description: 'Tratamientos de próstata con láser',
      icon: 'ri-flashlight-line',
      color: 'orange',
      details: 'Litotripsia láser y tratamiento de estenosis uretrales con tecnología de última generación.',
      benefits: ['Sin incisiones', 'Ambulatorio', 'Recuperación inmediata', 'Alta efectividad'],
      image: 'https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/a34b535219bdc3f1fd02caf0353d08bb.jpeg'
    },
    {
      id: 6,
      title: 'Cirugía de Parafimosis/Circuncisión',
      description: 'Procedimientos especializados del prepucio',
      icon: 'ri-scissors-line',
      color: 'dark',
      details: 'Cirugías especializadas para el tratamiento de parafimosis, fimosis y circuncisión con técnicas modernas que garantizan resultados óptimos y recuperación rápida.',
      benefits: ['Técnica precisa', 'Mínimo dolor', 'Recuperación rápida', 'Excelentes resultados estéticos'],
      image: 'https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/ccfaf1a9d6d04a9e6e4a1b2470f246c9.webp'
    }
  ];

  const colorClasses = {
    teal: 'text-white',
    green: 'bg-green-500 text-white',
    purple: 'bg-purple-500 text-white',
    red: 'bg-red-500 text-white',
    orange: 'bg-orange-500 text-white',
    dark: 'text-white'
  };

  return (
    <section id="tratamientos" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Tratamientos Especializados
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ofrecemos una amplia gama de tratamientos urológicos con tecnología de última generación para garantizar los mejores resultados.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {treatments.map((treatment) => (
            <div 
              key={treatment.id}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
              onClick={() => setSelectedTreatment(treatment)}
            >
              <div className="relative h-48">
                <img 
                  src={treatment.image}
                  alt={treatment.title}
                  className="w-full h-full object-cover object-center"
                />
                <div 
                  className={`absolute top-4 left-4 w-12 h-12 ${colorClasses[treatment.color]} rounded-full flex items-center justify-center`}
                  style={{ 
                    backgroundColor: treatment.color === 'teal' ? '#168B98' : 
                                   treatment.color === 'dark' ? '#1A1A1A' : undefined 
                  }}
                >
                  <i className={`${treatment.icon} text-xl`}></i>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {treatment.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {treatment.description}
                </p>
                <button className="font-semibold hover:opacity-80 transition-colors whitespace-nowrap cursor-pointer" style={{ color: '#168B98' }}>
                  Ver detalles <i className="ri-arrow-right-line ml-1"></i>
                </button>
              </div>
            </div>
          ))}
        </div>
        
        {selectedTreatment && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
              <div className="relative">
                <img 
                  src={selectedTreatment.image}
                  alt={selectedTreatment.title}
                  className="w-full h-64 object-cover object-center"
                />
                <button 
                  onClick={() => setSelectedTreatment(null)}
                  className="absolute top-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-xl text-gray-700"></i>
                </button>
              </div>
              
              <div className="p-8">
                <div className="flex items-center mb-4">
                  <div 
                    className={`w-12 h-12 ${colorClasses[selectedTreatment.color]} rounded-full flex items-center justify-center mr-4`}
                    style={{ 
                      backgroundColor: selectedTreatment.color === 'teal' ? '#168B98' : 
                                     selectedTreatment.color === 'dark' ? '#1A1A1A' : undefined 
                    }}
                  >
                    <i className={`${selectedTreatment.icon} text-xl`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">
                    {selectedTreatment.title}
                  </h3>
                </div>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {selectedTreatment.details}
                </p>
                
                <h4 className="text-lg font-semibold text-gray-900 mb-4">Beneficios:</h4>
                <div className="grid grid-cols-2 gap-3 mb-6">
                  {selectedTreatment.benefits.map((benefit, index) => (
                    <div key={index} className="flex items-center">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      <span className="text-gray-700">{benefit}</span>
                    </div>
                  ))}
                </div>
                
                <a 
                  href="https://api.whatsapp.com/send/?phone=+523317097105&text=Hola+Dr.+Eduardo+Cabeza+Bucio%2C+me+gustar%C3%ADa+agendar+una+consulta&type=phone_number&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full text-white py-3 rounded-lg font-semibold hover:opacity-90 transition-colors whitespace-nowrap cursor-pointer text-center"
                  style={{ backgroundColor: '#168B98' }}
                >
                  Agendar Consulta - $1,000
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
